import { getDecodedID, getEncodedID } from "./encodeAndDecode.utils";

export const getDecodedWorksheetId = (id: string) => {
  const [budgetId, proposalId, worksheetId] = JSON.parse(getDecodedID(id).split(":")[1]) as [number, number, number];
  return { budgetId, proposalId, worksheetId };
};

type GetEncodedWorksheetIdParams = {
  budgetId: string | number;
  proposalId: string | number;
  worksheetId: string | number;
};
export const getEncodedWorksheetId = ({ budgetId, proposalId, worksheetId }: GetEncodedWorksheetIdParams) =>
  getEncodedID(`Operation:[${budgetId},${proposalId},${worksheetId}]`);

type GetWorksheetLinkParams = {
  subdomain: string;
  budgetId: number;
  proposalId: number;
  ledgerType: string;
  worksheetId: string | number;
  shouldShowPositionRequest?: boolean;
  isPreDateBasedBudget?: boolean;
  proposalSummaryUsabilityFeatureEnabled?: boolean;
};
export const getWorksheetLink = ({
  subdomain,
  budgetId,
  proposalId,
  ledgerType,
  worksheetId,
  shouldShowPositionRequest,
  isPreDateBasedBudget = false,
  proposalSummaryUsabilityFeatureEnabled = false,
}: GetWorksheetLinkParams) => {
  const encodedBudgetId = btoa(`Budget:${budgetId}`);
  const encodedProposalId = btoa(`Proposal:[${budgetId},${proposalId}]`);
  const encodedWorksheetId = getEncodedWorksheetId({ budgetId, proposalId, worksheetId });

  if (proposalSummaryUsabilityFeatureEnabled && !isPreDateBasedBudget) {
    return `/budgets/${subdomain}/${encodedBudgetId}/proposals/${encodedProposalId}/adjustments/${worksheetId.toString()}`;
  }

  if (shouldShowPositionRequest && ledgerType === "revenues") {
    return `/budgets/${subdomain}/${encodedBudgetId}/proposals/${encodedProposalId}/worksheets/${encodedWorksheetId}`;
  }

  return shouldShowPositionRequest
    ? `/budgets/${subdomain}/${encodedBudgetId}/proposals/${encodedProposalId}/worksheets/${encodedWorksheetId}/adjustments`
    : `/budgets/${subdomain}/${encodedBudgetId}/proposals/${encodedProposalId}/operations/${ledgerType}/${encodedWorksheetId}`;
};
